import { WeatherIcons } from '$tablet-app/assets/weatherIcons';
import { Text } from '@akin-home/text/native';
import { weather_functions } from '@akin-home/weather';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { ChatItemDialogBody, ChatItemHeader } from '../../ChatItem';
import { ChatWeatherItem } from '../../ChatItem/types';
import { useDismissChatItemDialog } from '../ChatItemDialog';
import { ChatItemDialogProps } from '../ChatItemDialog/ChatItemDialogProps';

export const WeatherChatDialog = (
  props: ChatItemDialogProps<ChatWeatherItem>
) => {
  const {
    chat_item: {
      data: { weather_data },
    },
  } = props;

  const onDismiss = useDismissChatItemDialog();

  return (
    <>
      <ChatItemHeader title="weather" onDismiss={onDismiss} />
      <ChatItemDialogBody>
        <TopContainer>
          <IconTextContainer>
            <BigIcon
              source={WeatherIcons[weather_functions.getIcon(weather_data)]}
            />

            {/* <View>
              {location ? (
                <Text variant="h3" weight="bold" color="white">
                  {location}
                </Text>
              ) : null}
            </View> */}
          </IconTextContainer>

          <TextContainer>
            <DescriptionText weight="semibold" color="white">
              {weather_functions.getWeatherDescription(weather_data)}
            </DescriptionText>
            <TemperatureText weight="semibold" color="white">
              {weather_functions.getTemperatureText(weather_data)}
            </TemperatureText>

            {/* <Text color="white">{`P: ${precipitation?.[0]}%   H: ${humidity?.[0]}%`}</Text> */}
          </TextContainer>
        </TopContainer>
      </ChatItemDialogBody>
    </>
  );
};

const TopContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
`;

const IconTextContainer = styled.View`
  flex-direction: row;
`;

const BigIcon = styled.Image`
  width: 100px;
  aspect-ratio: 1;

  margin-right: 35px;
`;

const TextContainer = styled(View)`
  max-width: 100%;
  flex: 1;
  margin-left: auto;
  align-items: flex-end;
`;

const DescriptionText = styled(Text)`
  text-align: right;
  margin-right: 5px;
`;

const TemperatureText = styled(Text)`
  font-size: 48px;
  text-align: right;
`;
